/* ==========================================================================
   Elevate Floors — Seção 07: How it works

   Duas coisas apenas: a revelação em cascata na entrada e o botão do mobile.
   O hover é CSS puro — :hover na coluna resolve, e é mais rápido do que
   qualquer estado gerenciado por JS.
   ========================================================================== */
(function () {
  'use strict';

  function initSection(section) {
    if (section._efProcessBound) return;
    section._efProcessBound = true;

    /* ---- revelação em cascata, UMA vez só ---- */
    var reveal = section.querySelector('[data-reveal]');
    if (reveal) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          reveal.classList.add('is-in');
          io.disconnect();   // não reanima quando a pessoa rola de volta
        }, { threshold: 0.15 });
        io.observe(reveal);
      } else {
        reveal.classList.add('is-in');
      }
    }

    /* ---- a folha mobile ----
       Substitui o antigo expandir inline. O estado vive numa classe no <body>,
       então todo o CSS de abertura é declarativo: o JS só liga e desliga. */
    var opener = section.querySelector('[data-hiw-open]');
    var sheet = section.querySelector('.ef-hiw');
    if (!opener || !sheet || opener._efHiwBound) return;
    opener._efHiwBound = true;

    var scrollY = 0;

    function openSheet() {
      /* Trava o scroll guardando a posição. NÃO usar position:fixed no body
         para isso: a página tem rodapé fixo com espaçador medido em JS, e
         mudar a altura do documento faria o espaçador ser recalculado errado.
         overflow:hidden no <html> trava sem mexer na altura. */
      scrollY = window.scrollY;
      // a foto de fundo só é baixada aqui (ver o comentário no Liquid)
      var ph = sheet.querySelector('.ef-hiw__photo[data-src]');
      if (ph) { ph.src = ph.getAttribute('data-src'); ph.removeAttribute('data-src'); }
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('hiw-open');
      sheet.setAttribute('aria-hidden', 'false');
      opener.setAttribute('aria-expanded', 'true');
      var close = sheet.querySelector('.ef-hiw__close');
      if (close) close.focus({ preventScroll: true });
    }

    function closeSheet() {
      if (!document.body.classList.contains('hiw-open')) return;
      document.body.classList.remove('hiw-open');
      document.documentElement.style.overflow = '';
      window.scrollTo(0, scrollY);
      sheet.setAttribute('aria-hidden', 'true');
      opener.setAttribute('aria-expanded', 'false');
      opener.focus({ preventScroll: true });
    }

    opener.addEventListener('click', openSheet);

    /* o scrim, o × e o botão Free estimate — este último fecha junto, senão a
       página rolaria até o formulário com a folha aberta na frente */
    sheet.querySelectorAll('[data-hiw-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
    });
  }

  function init() {
    document.querySelectorAll('[data-process]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
